import './style.scss'
import { InstructorSearchResultProfile } from '../../server/types';
import { getProfilePicPath, getSmallProfilePicPath } from '../../constants/instructorConstants';
import { PAGE_URLS } from '../../constants/hrefLinks';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { userStateData } from '../../data/userStateData';
import { updateLikedProfiles } from '../../redux/reducers/searchSlice';
import { LazyLoadImage } from 'react-lazy-load-image-component'
import { useEffect, useState } from 'react';

interface AppSearchResultProfileProps {
	profile: InstructorSearchResultProfile
}

function AppSearchResultProfile({profile}: AppSearchResultProfileProps) {
	const likedProfiles: string[] = useAppSelector(state => state.search.likedProfiles)
	const renderProfileLikes: number = useAppSelector(state => state.search.renderProfileLikes)
	const innerWidth: number = useAppSelector(state => state.resize.innerWidth)

	const [profileIsLiked, setProfileIsLiked] = useState<boolean>(false)
	
	const dispatch = useAppDispatch()

	const toggleProfileLike = (profileId: string) => {
		userStateData.toggleLikesInstructor(profileId)
		dispatch(updateLikedProfiles())
	}

	useEffect(() => {
		let isLiked: boolean = false
		likedProfiles.forEach((value: string) => {
			if (value == profile.id) {
				isLiked = true
			}
		})
		setProfileIsLiked(isLiked)
	}, [renderProfileLikes])

	return (
		<div
			className="app-seach-result-profile-wrap"
		>
			<a
				href={`${PAGE_URLS.APP_INSTRUCTOR}?id=${profile.id}`}
				aria-label={`Visit the profile page for Instructor ${profile.name}`}
			>
				<LazyLoadImage
					className='app-seach-result-profile-img'
					src={innerWidth < 500 ? getSmallProfilePicPath(profile.profile_pics, 0) : getProfilePicPath(profile.profile_pics, 0)}
					alt='Instructor profile'
					loading="lazy"
					fetchPriority='high'
				/>
			</a>
			<img
				className='app-seach-result-profile-like-button'
				src={profileIsLiked ? '/imgs/icons/explore/icon-instructor-heart-button-filled.svg' : '/imgs/icons/explore/icon-instructor-heart-button.svg'}
				alt='Heart'
				onClick={() => toggleProfileLike(profile.id)}
			/>
			<div className='app-search-result-profile-details-wrap'>
				<div className='app-seach-result-profile-name'>{profile.name}</div>
				{/* <div className='seach-result-profile-school'>{INSTRUCTOR_SCHOOLS[profile.school].toLowerCase() == 'none' ? '' : INSTRUCTOR_SCHOOLS[profile.school]}</div> */}
				<div className='app-seach-result-profile-level'>Level {profile.level}</div>
				<div className='app-seach-result-profile-years'>{profile.years_of_experience ? `${profile.years_of_experience}+` : '?'} Years Experience</div>
				<div className='seach-result-profile-price-wrap'>
					<div className='app-seach-result-profile-price-value'>{`$${profile.price}`} NZD</div>
					<div className='app-seach-result-profile-price-label'> per session</div>
					<div className='app-search-result-profile-rating'>
						{Number(profile.rating_overall) > 0 &&
							<>
								<img 
									src={`/imgs/icons/explore/icon-star.svg`}
									className='app-search-result-profile-rating-icon'
									alt={`Rating star`}
								/>
								{profile.rating_overall}
							</>
						}
					</div>
				</div>
			</div>
		</div>
	)
}

export default AppSearchResultProfile
